import SymbolIcon from './SymbolIcon'
import ItemSlider from './ItemSlider'
import Notificacion from './Notificacion'
import modal from './Modal'

export const Modal = modal;
export {
    SymbolIcon, ItemSlider, Notificacion
}